import React, { forwardRef, useContext } from "react";
import { FeatureSelectionOptionsContext } from "../../../settings/components/FeatureSelectionOptionsContext";
import { Typography } from "@mui/material";
import MustDoActionConfig from "./components/MustDoActionConfig";
import "./mustDoAction.css";
import "../mandatoryConfigCommon.css";
import ResetButton from "../../../../components/resetButton/ResetButton";
const MustDoAction = forwardRef<any, {}>(function MustDoAction(props, ref) {
  const [triggerReset, setTriggerReset] = React.useState(0);

  const handleReset = () => {
    setTriggerReset((prev) => prev + 1);
  };

  return (
    <div className="config-container-left">
      <MustDoActionConfig
        triggerReset={triggerReset}
        inputLengthValidations={{
          max: { title: 25, unit: 9 },
          min: { title: 5, unit: 2 },
        }}
        handleReset={handleReset}
        ref={ref}   
      />
    </div>
  );
});


const MustDoActionHeading: React.FC<{ handleReset: () => void }> = ({ handleReset }) => {
  const {
      uiConfigOptionsProp = [],
      setUiConfigOptionsProp = () => {},
    } = useContext(FeatureSelectionOptionsContext);
  const featureDescription = uiConfigOptionsProp
    .filter((option) => option.id === "Must Do Action")
    .map((option) => option.description);

  return (
    <div className="config-heading">
      <div>
        <Typography
          sx={{
            fontSize: { xs: "1rem", md: "1.2rem", xl: "2rem" },
            color: "#227C9D",
          }}
        >
          <span style={{ color: "#00C6B1", fontWeight: "bold" }}>
            AI GENERATED TASK
          </span>
          &nbsp;CONFIGURATION
        </Typography>
        <Typography
          // marginTop={1}
          style={{ fontSize: "clamp(0.4rem, 0.8vw + 0.1rem, 1.8rem)" }}
        >
          {featureDescription}
        </Typography>
      </div>
      <div className="uiConfig-reset-button">
        <ResetButton
          onReset={handleReset}
          buttonLabel="RESET DEFAULT"
        />
      </div>
    </div>
  );
};
export default MustDoAction;
